'use strict';

import React, {useCallback, useMemo, useState, useEffect} from 'react';
import {h, Fragment} from 'preact';
import ReactDOM, {render} from 'react-dom';
import {trans} from '../../../l10n';
import mix from '../../../helpers/mix';

function BigPhoto(props) {
    const goodsName = useMemo(() => {
        return $('h1').text();
    }, []);

    const pictures = useMemo(() => {
        return $('.thumbs A')
            .map(function () {
                return $(this).attr('href');
            })
            .toArray();
    }, []);

    const [currentIndex, setCurrentIndex] = useState(props.index || 0);
    const [loadedPictures, setLoadedPictures] = useState([currentIndex]);

    useEffect(() => {
        setCurrentIndex(props.index);
        setLoadedPictures([props.index]);
    }, [props.index]);

    const open = useCallback(() => {
        window.open(pictures[currentIndex]);
    }, [pictures, currentIndex]);

    const goLeft = useCallback(() => {
        let index = currentIndex - 1;

        if (index < 0) {
            index = pictures.length - 1;
        }

        setCurrentIndex(index);
    }, [currentIndex, pictures]);

    const goRight = useCallback(() => {
        let index = currentIndex + 1;

        if (index > pictures.length - 1) {
            index = 0;
        }

        setTimeout(() => {
            setCurrentIndex(index);
            setLoadedPictures([...loadedPictures, index]);
        }, 1);
    }, [currentIndex, pictures]);

    const showZoom = false;

    const close = useCallback(() => {
        $('.big-photo-wrapper').fadeOut();
    }, []);

    const logo = useMemo(() => {
        return LOCALE === 'uk_ua' ? '/images/logo_light_ua.svg' : '/images/logo_light_ru.svg';
    }, []);

    return (
        <div className='product__slideshow'>
            <div className='big-photo-wrapper'>
                <div className='big-photo'>
                    <div className='big-photo-header'>
                        <div>
                            <img src={logo} alt="logo" width="234" height="50"/>
                        </div>
                    </div>

                    <div className='big-photo-title'>
                        <div className='big-photo-good-name'>{goodsName}</div>
                        <div className='big-photo-close' onClick={close}></div>
                    </div>

                    <div className='big-photo-container'>
                        {pictures.length > 0 && (
                            <a rel="nofollow" href='javascript:void(0)' className='big-photo-left' onClick={goLeft}></a>
                        )}

                        <div className='big-photo-image'>
                            {pictures.map((photo, index) => (
                                <div
                                    className='big-photo-image-inner'
                                    style={{display: currentIndex === index ? 'block' : 'none'}}
                                    key={index}>
                                    {loadedPictures.indexOf(index) !== -1 && <img src={photo} className='img' />}
                                </div>
                            ))}
                        </div>

                        {pictures.length > 0 && (
                            <a rel="nofollow" href='javascript:void(0)' className='big-photo-right' onClick={goRight}></a>
                        )}
                    </div>

                    <div className='big-photo-footer'>
                        {/*Оригинальное фото в отдельном окне*/}
                        <a rel="nofollow" className='big-photo-open' href='javascript:void(0)' onClick={open}>
                            {trans('bigPhoto.open')}
                        </a>

                        {showZoom && <div className='big-photo-zoom'></div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

// Big photo
$('.full_size a').click(function (ev) {
    ev.preventDefault();

    const target = document.querySelector('#js-product-big-photo');

    if (target) {
        mix.loadCSS('css/desktop/big-photo.css');

        ReactDOM.render(<BigPhoto index={$('#thumbs .selected .thumb').data('index')} />, target, () => {
            setTimeout(() => {
                $('.big-photo-wrapper').show();
            }, 100);
        });
    }

    tracker.track('Страница товара => Нажатие "большое фото"', {url: document.baseURI});
});

/*
require('../../../jquery-ui');

$('.zoomIMG').click(function() {
    $('#img_container img').toggleClass('img');
    $('.zoomIMG').toggleClass('zoom2');
    $('#img_container2').toggleClass('curs');
});

$('#img_container img').draggable();*/
